var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4584 22.2084L23.7397 11.9272L21.698 9.8855L13.4584 18.1251L9.30216 13.9688L7.2605 16.0105L13.4584 22.2084ZM15.5001 30.0834C13.4827 30.0834 11.5869 29.7006 9.81258 28.935C8.03828 28.1694 6.49487 27.1303 5.18237 25.8178C3.86987 24.5053 2.83081 22.9619 2.06519 21.1876C1.29956 19.4133 0.916748 17.5174 0.916748 15.5001C0.916748 13.4827 1.29956 11.5869 2.06519 9.81258C2.83081 8.03828 3.86987 6.49487 5.18237 5.18237C6.49487 3.86987 8.03828 2.83081 9.81258 2.06519C11.5869 1.29956 13.4827 0.916748 15.5001 0.916748C17.5174 0.916748 19.4133 1.29956 21.1876 2.06519C22.9619 2.83081 24.5053 3.86987 25.8178 5.18237C27.1303 6.49487 28.1694 8.03828 28.935 9.81258C29.7006 11.5869 30.0834 13.4827 30.0834 15.5001C30.0834 17.5174 29.7006 19.4133 28.935 21.1876C28.1694 22.9619 27.1303 24.5053 25.8178 25.8178C24.5053 27.1303 22.9619 28.1694 21.1876 28.935C19.4133 29.7006 17.5174 30.0834 15.5001 30.0834ZM15.5001 27.1667C18.757 27.1667 21.5157 26.0365 23.7761 23.7761C26.0365 21.5157 27.1667 18.757 27.1667 15.5001C27.1667 12.2431 26.0365 9.48446 23.7761 7.22404C21.5157 4.96362 18.757 3.83341 15.5001 3.83341C12.2431 3.83341 9.48446 4.96362 7.22404 7.22404C4.96362 9.48446 3.83341 12.2431 3.83341 15.5001C3.83341 18.757 4.96362 21.5157 7.22404 23.7761C9.48446 26.0365 12.2431 27.1667 15.5001 27.1667Z",
    fill: "url(#paint0_linear_589_6505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_589_6505",
    x1: 0.916748,
    y1: 15.5001,
    x2: 30.0834,
    y2: 15.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#00B69B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#038370"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutline);
export default __webpack_public_path__ + "static/media/check-outline.09dda9fcb2210d1fe090772be0776c49.svg";
export { ForwardRef as ReactComponent };